import {
  SET_JWT,
  SET_CURRENT_USER,
  SET_TOUCH_INPUT_ORDER,
  SET_TOUCH_INPUT_PARTNUMBER,
  SET_CURRENT_IMAGES,
  SET_PART_IMAGES,
  SET_DEVICE_SETUP,
  SET_DEVICE_LANGUAGE,
  SET_SCANCODE,
  SET_PERMISSIONS_OF_USER,
  INITIALIZE_ACTIVITY,
  ADD_ACTIVITY_VALUE,
  ADD_ACTIVITY_CHARACTERISTIC,
  ADD_ACTIVITY_META,
  UPDATE_ACTIVITY_META,
  SET_SELECTED_PIVOT_ITEM,
  SET_MAIN_ACTIVITY,
  SET_IS_DISABLED_SAVE_BUTTON,
  SET_IS_PART_DETECTION,
  SET_DMC,
  SET_TOUCH_INPUT_EMPLOYEE,
  RESET_TOUCH_INPUT,
  SET_CLOSE_CHARACTERISTICS_SLIDER_ICON,
  SET_META_INPUT,
  REMOVE_META_INPUT,
  SET_LAST_PARTNUMBER,
  SET_PARTNUMBER_HAS_CHANGED,
  REMOVE_META_INPUT_ALL,
  SET_META_REQUIRED,
  SET_DASHBOARD,
  UPDATE_TILE,
  SET_DASHBOARD_ROWS,
  SET_LAST_DASHBOARD,
  SET_SCANINPUT_CAMERA,
  SET_DATAGRID,
  SET_CURRENT_USER_SETTINGS,
  SET_SELECTED_BRANCHES,
  SET_SELECTED_SUBSIDIARIES,
  SET_GLOBAL_DATETIMERANGE_SELECTION,
  SET_TIME_RECORDING_DATE_SELECTION,
} from './actionTypes';

export function setJWT(jwt) {
  return { type: SET_JWT, jwt };
}

export function setCurrentUser(currentUser) {
  return { type: SET_CURRENT_USER, currentUser };
}

export function setCurrentUserSettings(settings) {
  return { type: SET_CURRENT_USER_SETTINGS, settings };
}

export function setPermissionsOfUser(userRoles) {
  return { type: SET_PERMISSIONS_OF_USER, userRoles };
}

export function setTouchInputPartnumber(partnumber) {
  return { type: SET_TOUCH_INPUT_PARTNUMBER, partnumber };
}

export function setTouchInputOrder(order) {
  return { type: SET_TOUCH_INPUT_ORDER, order };
}

export function setTouchInputEmployee(employee) {
  return { type: SET_TOUCH_INPUT_EMPLOYEE, employee };
}

export function resetTouchInput() {
  return { type: RESET_TOUCH_INPUT };
}

export function setPartImages(partImages) {
  return { type: SET_PART_IMAGES, partImages };
}

export function setCloseCharacteristicSliderIcon(
  closeCharacteristicSliderIcon
) {
  return {
    type: SET_CLOSE_CHARACTERISTICS_SLIDER_ICON,
    closeCharacteristicSliderIcon,
  };
}

export function setCurrentImages(currentImages) {
  return { type: SET_CURRENT_IMAGES, currentImages };
}

export function setDeviceSetup(deviceSetup) {
  return { type: SET_DEVICE_SETUP, deviceSetup };
}

export function setDeviceLanguage(deviceLanguage) {
  return { type: SET_DEVICE_LANGUAGE, deviceLanguage };
}

export function setScancode(scancode) {
  return { type: SET_SCANCODE, scancode };
}

export function initializeActivity(activity) {
  return { type: INITIALIZE_ACTIVITY, activity: activity };
}

export function addActivityValue(activity) {
  return { type: ADD_ACTIVITY_VALUE, activity: activity };
}

export function addActivityCharacteristic(characteristic) {
  return { type: ADD_ACTIVITY_CHARACTERISTIC, characteristic: characteristic };
}

export function addActivityMeta(meta) {
  return { type: ADD_ACTIVITY_META, meta: meta };
}

export function updateActivityMeta(meta) {
  return { type: UPDATE_ACTIVITY_META, meta: meta };
}

export function setSelectedPivotItem(key, value) {
  return {
    type: SET_SELECTED_PIVOT_ITEM,
    payload: { key: key, value: value.substring(2) + '' },
  };
}

export function setMainActivity(mainActivity) {
  return { type: SET_MAIN_ACTIVITY, mainActivity: mainActivity };
}

export function setIsDisabledSaveButton(bool) {
  return { type: SET_IS_DISABLED_SAVE_BUTTON, isDisabledSaveButton: bool };
}

export function setIsPartDetection(isPartDetection) {
  return { type: SET_IS_PART_DETECTION, isPartDetection: isPartDetection };
}

export function setDMC(dmc) {
  return { type: SET_DMC, dmc: dmc };
}

export function setMetaInput(key, metaInput) {
  return {
    type: SET_META_INPUT,
    payload: {
      new: { id: key, value: metaInput },
    },
  };
}

export function removeMetaInput(key) {
  return {
    type: REMOVE_META_INPUT,
    payload: {
      removeId: key,
    },
  };
}

export function removeAllLockedMetaInput() {
  return {
    type: REMOVE_META_INPUT_ALL,
  };
}

export function setLastPartnumber(partnumber) {
  return {
    type: SET_LAST_PARTNUMBER,
    payload: {
      lastPartnumber: partnumber,
    },
  };
}

export function setChangedPartnumber(bool) {
  return {
    type: SET_PARTNUMBER_HAS_CHANGED,
    payload: {
      changedPartnumber: bool,
    },
  };
}

export function setHasRequired(bool) {
  return {
    type: SET_META_REQUIRED,
    payload: {
      hasRequired: bool,
    },
  };
}

export function setDashboard(dashboard) {
  return {
    type: SET_DASHBOARD,
    id: dashboard.id,
    caption: dashboard.caption,
    content: dashboard.content,
    dashboardType: dashboard.type,
    order: dashboard.order,
  };
}

export function setDashboardRows(rows) {
  return {
    type: SET_DASHBOARD_ROWS,
    rows: rows,
  };
}

export function setLastDashboard(orderNumber, dashboardId) {
  return {
    type: SET_LAST_DASHBOARD,
    orderNumber: orderNumber,
    dashboardId: dashboardId,
    lastUsed: Date.now(),
  };
}

/**
 * @typedef {Object} PayloadValues
 * @property {Date} from
 * @property {Date} to
 * @property {string} rangeToggle
 * @property {string} selectedData
 * @typedef {{ key: string; values: PayloadValues; }} ActionPayload
 * @typedef {{ type: string; payload: ActionPayload; }} Action
 *
 * @description
 * This function creates the action object which will be dispatched to the redux
 * store. The action will then cause an update within the store.
 *
 * @param {string} key The key used to associate the stored values.
 * @param {PayloadValues} values The updated values ready to be stored.
 * @returns {Action}
 * The action object which is used to trigger an update within the redux store.
 */
export function setDateTimeRangeSelection(key, values) {
  return {
    type: SET_GLOBAL_DATETIMERANGE_SELECTION,
    payload: {
      key,
      values,
    },
  };
}

export function updateTile(tile) {
  return {
    type: UPDATE_TILE,
    tile: tile,
  };
}

export function updateCamera(cameraDeviceId) {
  return {
    type: SET_SCANINPUT_CAMERA,
    cameraDeviceId: cameraDeviceId,
  };
}

export function setDatagrid(datagrid) {
  return {
    type: SET_DATAGRID,
    id: datagrid.id,
    caption: datagrid.caption,
    columnState: datagrid.columnState,
    columnGroupState: datagrid.columnGroupState,
    filter: datagrid.filter,
    isPivotMode: datagrid.isPivotMode,
    dashboardType: datagrid.type,
    order: datagrid.order,
  };
}

export function setBranches(branches) {
  return { type: SET_SELECTED_BRANCHES, branches: branches };
}

export function setSubsidiaries(subsidiaries) {
  return { type: SET_SELECTED_SUBSIDIARIES, subsidiaries: subsidiaries };
}

/**
 * @param {Date} selectedDate
 * @returns {Redux.TimeRecordingDateSelection.Action}
 */
export function setTimeRecordingDateSelection(selectedDate) {
  return {
    type: SET_TIME_RECORDING_DATE_SELECTION,
    selectedDate,
  };
}
